var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 80,
    viewBox: "0 0 216 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1487_5266)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 80,
    rx: 8,
    fill: "url(#paint0_linear_1487_5266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.128 28.528C25.184 26.6933 25.9787 24.6453 26.512 22.384L28.032 22.672C27.8507 23.376 27.6693 24.0107 27.488 24.576H32.784V26.032L31.376 29.28L30 28.72L31.28 26.096H26.976C26.56 27.2267 26.0533 28.3147 25.456 29.36L24.128 28.528ZM23.536 34.752C23.216 34.176 22.7787 33.4187 22.224 32.48C21.4987 34.0053 20.64 35.36 19.648 36.544L18.784 35.008C19.7653 33.8987 20.6027 32.544 21.296 30.944C20.4 29.4827 19.616 28.2507 18.944 27.248L20.144 26.4C20.752 27.328 21.216 28.0427 21.536 28.544L21.936 29.168C22.3093 27.9627 22.576 26.6933 22.736 25.36H19.072V23.84H24.32V25.36C24 27.312 23.5413 29.1093 22.944 30.752C23.1573 31.104 23.28 31.3067 23.312 31.36C24.08 32.576 24.6027 33.4293 24.88 33.92L23.536 34.752ZM29.056 28.848C29.1627 30.288 29.5627 31.5627 30.256 32.672C30.96 33.7813 31.9733 34.7413 33.296 35.552L32.24 37.024C30.4053 35.7653 29.1413 34.1653 28.448 32.224C28.1067 33.1307 27.6053 33.9893 26.944 34.8C26.2827 35.6 25.424 36.4 24.368 37.2L23.216 35.904C24.304 35.1787 25.1573 34.4587 25.776 33.744C26.3947 33.0293 26.8373 32.2667 27.104 31.456C27.3813 30.6347 27.5307 29.6907 27.552 28.624V27.904V26.944H29.056V28.64V28.848ZM39.232 32.128C39.3813 32 39.472 31.8933 39.504 31.808C39.5467 31.7227 39.568 31.6107 39.568 31.472V23.776C40.0693 23.648 40.6133 23.4773 41.2 23.264C41.7867 23.04 42.3147 22.816 42.784 22.592L43.376 24.08C42.5227 24.5067 41.76 24.8213 41.088 25.024V31.264L42.928 30.256L43.088 31.984L39.76 33.632L39.232 32.128ZM36.528 22.672C36.8587 23.0987 37.312 23.7013 37.888 24.48L38.736 25.616L37.504 26.688C37.2693 26.336 36.9227 25.856 36.464 25.248C36.016 24.6293 35.6213 24.1013 35.28 23.664L36.528 22.672ZM43.536 23.488H48.496V31.44C48.496 32.1013 48.3413 32.56 48.032 32.816C47.7227 33.072 47.232 33.2 46.56 33.2H45.568L45.28 31.664H46C46.2987 31.6533 46.5173 31.6267 46.656 31.584C46.7947 31.5307 46.8853 31.4453 46.928 31.328C46.9707 31.2 46.992 30.9973 46.992 30.72V25.024H45.024V34.768H43.536V23.488ZM34.752 35.28L36.576 33.424V29.344H34.944V27.776H38.128V33.408C38.608 34.1013 39.1253 34.5813 39.68 34.848C40.2453 35.104 41.024 35.232 42.016 35.232H49.136L48.848 36.72H41.776C41.04 36.72 40.4267 36.6667 39.936 36.56C39.4453 36.4533 39.0027 36.2667 38.608 36C38.2133 35.744 37.8187 35.3653 37.424 34.864L35.504 36.976L34.752 35.28ZM65.184 35.408L64.88 36.8H61.04C60.048 36.8 59.2373 36.6453 58.608 36.336C57.9787 36.0373 57.44 35.5093 56.992 34.752C56.8107 35.1573 56.5813 35.5573 56.304 35.952C56.0373 36.336 55.7013 36.7467 55.296 37.184L54.144 36.24C54.656 35.7173 55.0507 35.2427 55.328 34.816C55.616 34.3893 55.8347 33.936 55.984 33.456C56.1333 32.9653 56.256 32.3467 56.352 31.6L57.76 31.728C57.696 32.272 57.6107 32.7467 57.504 33.152C57.7813 33.7707 58.08 34.24 58.4 34.56C58.72 34.88 59.104 35.104 59.552 35.232V31.168H55.296V30.096L54.032 30.576V35.36C54.032 35.776 53.9733 36.096 53.856 36.32C53.7493 36.544 53.568 36.704 53.312 36.8C53.056 36.896 52.6827 36.944 52.192 36.944H51.216L50.944 35.376H51.744C52.064 35.376 52.2773 35.3333 52.384 35.248C52.5013 35.152 52.56 34.9813 52.56 34.736V31.152C51.824 31.44 51.3013 31.6533 50.992 31.792L50.816 30.144C51.296 29.984 51.8773 29.7707 52.56 29.504V26.848H51.024V25.312H52.56V22.656H54.032V25.312H55.424V26.848H54.032V28.928L54.496 28.736L55.216 28.432L55.264 29.232L55.312 29.84H65.008V31.168H61.024V32.512H64.432V33.824H61.024V35.408H61.056H65.184ZM56.352 23.072H63.968V28.8H56.352V23.072ZM62.48 25.36V24.272H57.808V25.36H62.48ZM57.808 26.48V27.584H62.48V26.48H57.808ZM81.04 26.032V27.184H66.96V26.032H70.88C70.8693 25.9787 70.8533 25.92 70.832 25.856C70.8107 25.7813 70.7893 25.7067 70.768 25.632C70.7253 25.504 70.6773 25.3653 70.624 25.216C70.5813 25.056 70.5333 24.9013 70.48 24.752H67.776V23.616H73.296C73.1253 23.168 72.976 22.8213 72.848 22.576L74.672 22.304L75.184 23.616H80.24V24.752H77.472C77.3867 25.04 77.2267 25.4667 76.992 26.032H81.04ZM72.064 24.752C72.256 25.3067 72.3893 25.7333 72.464 26.032H75.424L75.872 24.752H72.064ZM79.376 27.936V32.688H74.288C74.768 33.1467 75.216 33.5947 75.632 34.032L74.608 34.976C74.064 34.3467 73.5467 33.7973 73.056 33.328L73.76 32.688H68.608V27.936H79.376ZM77.84 29.824V28.992H70.144V29.824H77.84ZM70.144 30.768V31.616H77.84V30.768H70.144ZM66.832 35.776C67.152 35.3707 67.4773 34.9013 67.808 34.368C68.1493 33.824 68.4373 33.3173 68.672 32.848L70.048 33.472C69.8027 33.984 69.488 34.5387 69.104 35.136C68.7307 35.7333 68.384 36.2293 68.064 36.624L66.832 35.776ZM79.296 32.88C79.872 33.68 80.512 34.6453 81.216 35.776L79.952 36.576C79.312 35.52 78.672 34.528 78.032 33.6L79.296 32.88ZM76.368 33.6L77.84 34L77.696 35.456C77.632 36 77.456 36.368 77.168 36.56C76.88 36.7627 76.3893 36.864 75.696 36.864H72.304C71.632 36.864 71.1627 36.736 70.896 36.48C70.6293 36.2347 70.496 35.776 70.496 35.104V33.168H72.064V34.896C72.064 35.1627 72.1173 35.3547 72.224 35.472C72.3413 35.5787 72.5547 35.632 72.864 35.632H75.344C75.7387 35.632 75.9947 35.584 76.112 35.488C76.24 35.392 76.3093 35.2107 76.32 34.944L76.368 33.6ZM93.6 24.688H86.448V32.144H84.8V23.136H95.232V31.968H93.6V24.688ZM96.976 32.528L96.944 33.232L96.88 34.816C96.848 35.328 96.752 35.7227 96.592 36C96.432 36.2667 96.1813 36.4587 95.84 36.576C95.4987 36.6933 95.0293 36.752 94.432 36.752H92.112C91.3333 36.752 90.784 36.592 90.464 36.272C90.144 35.9627 89.984 35.4027 89.984 34.592V32.272C89.504 33.2427 88.7733 34.1227 87.792 34.912C86.8213 35.6907 85.5147 36.4533 83.872 37.2L82.864 35.792C84.5173 35.1093 85.7813 34.4373 86.656 33.776C87.5413 33.1147 88.16 32.3893 88.512 31.6C88.8747 30.8107 89.0773 29.824 89.12 28.64C89.1627 27.232 89.184 26.2133 89.184 25.584H90.848C90.848 26.32 90.8267 27.3707 90.784 28.736C90.752 29.5253 90.6613 30.208 90.512 30.784H91.584V34.112C91.584 34.5493 91.6533 34.8427 91.792 34.992C91.9413 35.1413 92.224 35.216 92.64 35.216H94.144C94.496 35.216 94.752 35.1893 94.912 35.136C95.0827 35.072 95.2 34.9653 95.264 34.816C95.328 34.6667 95.3653 34.4373 95.376 34.128C95.408 33.296 95.424 32.6507 95.424 32.192L96.976 32.528Z",
    fill: "#3D4470"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1487_5266)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.5,
    cy: 33,
    rx: 39.5,
    ry: 29,
    fill: "#4149ED",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1487_5266)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -9,
    cy: 28,
    rx: 49,
    ry: 45,
    fill: "#86ABFF",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 12,
    cx: 99.5,
    cy: 51.5,
    r: 7.5,
    fill: "#DEDEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 49L102 51.5L99 54",
    stroke: "#26262A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 6,
    d: "M203.382 -14.0479L84.3129 105.223L221.984 96.4684L256.724 31.9207L203.382 -14.0479Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.593 50.838V55.986H30.233V57.247H22.42V55.986H25.267V46.054H26.593V49.525H29.791V50.838H26.593ZM21.38 49.356L20.717 48.485C20.5697 48.2857 20.366 48.017 20.106 47.679C19.8547 47.341 19.6597 47.0897 19.521 46.925L20.496 46.106C20.834 46.5133 21.471 47.3237 22.407 48.537L21.38 49.356ZM22.693 53.984L23.2 55.154L20.535 57.429L19.755 56.48C19.885 56.3847 19.9717 56.285 20.015 56.181C20.0583 56.0683 20.08 55.908 20.08 55.7V51.384H18.715V50.162H21.328V55.219L22.693 53.984ZM43.233 48.264H40.386L39.905 49.72H42.518V56.155C42.518 56.5797 42.4617 56.9047 42.349 57.13C42.2363 57.364 42.0543 57.5287 41.803 57.624C41.5603 57.7193 41.2223 57.767 40.789 57.767H39.281L39.086 56.74H40.438C40.7847 56.74 41.0143 56.6837 41.127 56.571C41.2483 56.4497 41.309 56.233 41.309 55.921V53.009L40.568 53.75L39.866 53.139V56.337H35.147V53.165C35.043 53.2517 34.7917 53.451 34.393 53.763L33.743 53.035V57.806H32.534V49.72H35.134L34.731 48.264H31.78V47.107H37.006L36.551 46.015L37.968 45.82C38.1413 46.184 38.3277 46.613 38.527 47.107H43.233V48.264ZM36.382 49.72H38.592L39.086 48.264H35.953L36.382 49.72ZM41.309 52.931V50.825H33.743V52.931C34.159 52.645 34.601 52.3027 35.069 51.904C35.5457 51.4967 35.9227 51.1457 36.2 50.851L36.98 51.54C36.7287 51.8 36.2303 52.2507 35.485 52.892H39.593L38.085 51.566L38.865 50.864L41.309 52.931ZM36.2 55.284H38.8V53.932H36.2V55.284ZM45.924 46.353H55.063V49.512H45.924V46.353ZM53.802 47.601V47.12H47.211V47.601H53.802ZM47.211 48.277V48.784H53.802V48.277H47.211ZM44.689 50.903V50.097H56.298V50.903H44.689ZM55.401 56.194H51.137V56.779H56.207V57.598H44.78V56.779H49.876V56.194H45.599V55.414H49.876V54.855H45.95V51.514H55.05V54.855H51.137V55.414H55.401V56.194ZM49.876 52.788V52.242H47.198V52.788H49.876ZM51.137 52.788H53.789V52.242H51.137V52.788ZM47.198 53.516V54.075H49.876V53.516H47.198ZM51.137 53.516V54.075H53.789V53.516H51.137ZM68.96 57.702C67.322 57.6067 66.0003 57.481 64.995 57.325C63.9897 57.1777 63.097 56.9393 62.317 56.61C61.875 56.8787 61.3247 57.1213 60.666 57.338C60.016 57.5547 59.2187 57.767 58.274 57.975L57.793 56.805C59.2837 56.4757 60.3497 56.1767 60.991 55.908C60.471 55.5613 59.925 55.115 59.353 54.569L60.133 53.815H58.885V48.615H62.876V47.614H57.975V46.483H69.077V47.614H64.176V48.615H68.167V53.815H64.098C63.994 54.6037 63.7427 55.245 63.344 55.739C63.9853 55.9383 64.7653 56.0943 65.684 56.207C66.6027 56.311 67.7813 56.389 69.22 56.441L68.96 57.702ZM62.876 50.682V49.681H60.159V50.682H62.876ZM66.906 50.682V49.681H64.176V50.682H66.906ZM62.876 51.683H60.159V52.723H62.876V52.528V51.683ZM64.176 52.723H66.906V51.683H64.176V52.567V52.723ZM60.263 53.815C60.8957 54.4303 61.5067 54.8983 62.096 55.219C62.4513 54.8723 62.681 54.4043 62.785 53.815H60.263ZM75.681 49.486C75.525 50.6993 75.3603 51.6873 75.187 52.45C75.0223 53.204 74.8013 53.8713 74.524 54.452C75.2173 55.0327 75.772 55.505 76.188 55.869L75.33 56.922L74.056 55.752C73.9693 55.6827 73.9043 55.6263 73.861 55.583C73.3237 56.311 72.5567 57.0823 71.56 57.897L70.611 56.935C71.1397 56.519 71.5817 56.142 71.937 55.804C72.2923 55.4573 72.6 55.0977 72.86 54.725C72.21 54.179 71.6337 53.7197 71.131 53.347C71.4603 52.0903 71.7247 50.8207 71.924 49.538H70.767V48.251H72.106C72.1927 47.5317 72.2707 46.769 72.34 45.963L73.588 46.067C73.5447 46.5783 73.4623 47.3063 73.341 48.251H75.681V49.486ZM82.337 51.345V52.645H79.763V56.142C79.763 56.7313 79.633 57.1387 79.373 57.364C79.113 57.598 78.658 57.715 78.008 57.715H76.695L76.422 56.389H77.631C77.969 56.389 78.19 56.3457 78.294 56.259C78.398 56.1637 78.45 55.9643 78.45 55.661V52.645H75.798V51.345H78.45V49.85L80.4 48.004H76.305V46.717H82.051V48.004L79.763 50.318V51.345H82.337ZM73.497 53.607C73.7137 53.1043 73.8957 52.528 74.043 51.878C74.199 51.228 74.3377 50.448 74.459 49.538H73.146C72.9467 50.7687 72.7213 51.8563 72.47 52.801L73.497 53.607Z",
    fill: "#3D4470"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd_1487_5266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.789 23.7492C185.385 23.9601 188.683 24.0652 190.667 26.1799C192.651 28.2946 192.545 31.5932 192.334 38.1895L192.238 41.1762C192.03 47.6985 191.926 50.9603 189.842 52.9396C187.758 54.9188 184.495 54.8543 177.971 54.7262L168.871 54.5466L163.609 58.6012L161.072 58.6402L163.151 53.9132L161.5 53.5009C156.367 52.8598 153.8 52.5394 152.136 50.9728C151.745 50.6039 151.396 50.1903 151.099 49.7418C149.837 47.8364 149.957 45.2524 150.195 40.0849L150.354 36.6488C150.654 30.1411 150.805 26.8864 152.912 24.9374C155.02 22.9888 158.275 23.0932 164.786 23.3014L178.789 23.7492Z",
    fill: "#F7FAFF",
    fillOpacity: 0.64,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_1487_5266)",
    "data-figma-bg-blur-radius": 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.978 20.4226C182.244 20.4384 185.877 20.4464 188.081 22.7273C190.286 25.0084 190.17 28.6394 189.937 35.9017L189.86 38.3185C189.634 45.3859 189.521 48.9201 187.256 51.0455C184.99 53.1708 181.456 53.0574 174.388 52.8314L168.548 52.6447L161.191 58.6411L160.697 52.3936L159.571 52.3576C152.343 52.1265 148.729 52.0113 146.595 49.6798C144.461 47.3482 144.665 43.7379 145.073 36.518L145.185 34.5431C145.565 27.8266 145.756 24.4683 147.93 22.4185C150.104 20.3687 153.467 20.3759 160.194 20.3905L174.978 20.4226Z",
    fill: "url(#paint1_linear_1487_5266)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 158.422,
    cy: 34.864,
    r: 3.08173,
    transform: "rotate(5 158.422 34.864)",
    fill: "white",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.667,
    cy: 35.4753,
    r: 3.08173,
    transform: "rotate(5 168.667 35.4753)",
    fill: "white",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.9,
    cy: 36.3718,
    r: 3.08173,
    transform: "rotate(5 178.9 36.3718)",
    fill: "white",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1487_5266",
    x: 37,
    y: -96,
    width: 279,
    height: 258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1487_5266"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1487_5266",
    x: -158,
    y: -117,
    width: 298,
    height: 290,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1487_5266"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_1487_5266_clip_path",
    transform: "translate(-80 -32)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 51.5,
    r: 7.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_1487_5266_clip_path",
    transform: "translate(-78.3129 20.0488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.382 -14.0479L84.3129 105.223L221.984 96.4684L256.724 31.9207L203.382 -14.0479Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_1487_5266",
    x: 138.043,
    y: 17.1934,
    width: 66.4003,
    height: 59.4473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.263655 0 0 0 0 0.19401 0 0 0 0 0.716346 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1487_5266"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.479729 0 0 0 0 0.589534 0 0 0 0 0.95032 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1487_5266",
    result: "effect2_dropShadow_1487_5266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1487_5266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_1487_5266",
    x: 138.811,
    y: 14.3887,
    width: 57.2456,
    height: 50.252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1487_5266"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_1487_5266_clip_path",
    transform: "translate(-138.811 -14.3887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.978 20.4226C182.244 20.4384 185.877 20.4464 188.081 22.7273C190.286 25.0084 190.17 28.6394 189.937 35.9017L189.86 38.3185C189.634 45.3859 189.521 48.9201 187.256 51.0455C184.99 53.1708 181.456 53.0574 174.388 52.8314L168.548 52.6447L161.191 58.6411L160.697 52.3936L159.571 52.3576C152.343 52.1265 148.729 52.0113 146.595 49.6798C144.461 47.3482 144.665 43.7379 145.073 36.518L145.185 34.5431C145.565 27.8266 145.756 24.4683 147.93 22.4185C150.104 20.3687 153.467 20.3759 160.194 20.3905L174.978 20.4226Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1487_5266",
    x1: 8.49999,
    y1: -8.99998,
    x2: 96.8257,
    y2: 123.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302885,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1487_5266",
    x1: 159.7,
    y1: 19.1564,
    x2: 202.994,
    y2: 55.5069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A7AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EABFF3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1487_5266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 80,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.8bc0c19862a99a90bd1f8dc2cf092ed9.svg";
export { ForwardRef as ReactComponent };